<div class="terms-condition">
  @if (isLoading) {
    <div class="loader-container">
      <img class="spin-loader" src="assets/images/loader-icon.gif" alt="Loading privacy policy" />
    </div>
  } @else {
    <div
      [innerHTML]="
        textDirection === 'rtl'
          ? sanitizerContent(content?.contentAr)
          : sanitizerContent(content?.contentEn)
      "
    ></div>
  }
</div>
